var __TEMP__ = require('./_copyArray.js');var copyArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_shuffleSelf.js');var shuffleSelf = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = arrayShuffle;
